import Dispatcher from 'common/Dispatcher';
import { ActionTypes } from 'search/constants';
import { EventEmitter } from 'events';
import SearchBoundingBoxStore from 'search/stores/BoundingBoxStore';

const CHANGE_EVENT = 'change';

// Export raw params for testing purposes.
export let _params = {};

const SearchParamsStore = Object.assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
   * @param {function} callback
   */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
   * @param {function} callback
   */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  get() {
    return Object.assign({}, _params);
  }
});

SearchParamsStore.dispatchToken = Dispatcher.register(payload => {
  const action = payload.action;

  switch (action.type) {
    case ActionTypes.SET_INITIAL_PARAMS:
      _params = action.initialParams || {};
      SearchParamsStore.emitChange();
      break;
    case ActionTypes.CHANGE_PAGE:
      _params.page = Number(action.page);
      if (_params.page < 2) {
        delete _params.page;
      }
      SearchParamsStore.emitChange();
      break;
    case ActionTypes.CHANGE_FILTER_EVENT_TYPE:
      _params.et = Number(action.eventTypeId);
      if (!_params.et) {
        delete _params.et;
      }
      delete _params.page;
      SearchParamsStore.emitChange();
      break;
    case ActionTypes.CHANGE_FILTER_PEOPLE:
      _params.people = action.people;
      if (!_params.people) {
        delete _params.people;
      }
      delete _params.page;
      SearchParamsStore.emitChange();
      break;
    case ActionTypes.CHANGE_FILTER_PEOPLE_FILTER:
      // TODO: Come up with a better name #peoplefilter
      _params.people_filter = action.filterType;
      if (!_params.people_filter) {
        delete _params.people_filter;
      }
      delete _params.page;
      SearchParamsStore.emitChange();
      break;
    case ActionTypes.CHANGE_FILTER_LOCATION:
      _params.location = action.location;
      delete _params.ne;
      delete _params.sw;
      delete _params.page;
      SearchParamsStore.emitChange();
      break;
    case ActionTypes.CHANGE_SEARCH_SORTING:
      _params.sort = action.sort;
      if (!_params.sort) {
        delete _params.sort;
      }
      delete _params.page;
      SearchParamsStore.emitChange();
      break;
    case ActionTypes.CHANGE_FILTER_VENUE_SERVICES:
      _params.vs = action.venueServices;
      delete _params.page;
      SearchParamsStore.emitChange();
      break;
    case ActionTypes.CHANGE_FILTER_VENUE_TITLE:
      _params.title = action.title;
      delete _params.page;
      SearchParamsStore.emitChange();
      break;
    case ActionTypes.SEARCH_FROM_MAP_AREA:
      Dispatcher.waitFor([SearchBoundingBoxStore.dispatchToken]);
      const bboxStore = SearchBoundingBoxStore;
      _params.sw = [bboxStore.getSouth(), bboxStore.getWest()];
      _params.ne = [bboxStore.getNorth(), bboxStore.getEast()];
      delete _params.location;
      delete _params.page;
      SearchParamsStore.emitChange();
      break;
    default:
    // do nothing
  }
});

export default SearchParamsStore;
